const labels = {
    az: { contextChanged: 'Giriş icazələri yeniləndi. Əlçatan bölmə göstərilir.', selectionUnavailable: 'Seçilmiş qeyd artıq əlçatan deyil. İcazə verilən siyahıya qayıtdınız.', sections: 'Kassa bölmələri', current: 'Cari bölmə', manage: 'İdarəetmə', rules: 'Daimi xərclər', advanced: 'Ətraflı idarəetmə', employees: 'Əməkdaşlar' },
    ru: { contextChanged: 'Права доступа обновлены. Открыт доступный раздел.', selectionUnavailable: 'Выбранная запись больше недоступна. Открыт доступный список.', sections: 'Разделы кассы', current: 'Текущий раздел', manage: 'Управление', rules: 'Регулярные расходы', advanced: 'Расширенное управление', employees: 'Сотрудники' },
    en: { contextChanged: 'Access was updated. Showing the available section.', selectionUnavailable: 'The selected record is no longer available. You are back in the permitted list.', sections: 'Cash sections', current: 'Current section', manage: 'Manage', rules: 'Recurring expenses', advanced: 'Advanced management', employees: 'Employees' },
};
export function cashNavigationText(locale, key) {
    return labels[locale][key];
}
export function cashTaskReturnLabel(locale, title) {
    if (locale === 'az')
        return title === 'Hesablar' ? 'Pul' : title;
    if (locale === 'ru') {
        if (title === 'К оплате')
            return 'К выплатам';
        if (title === labels.ru.rules)
            return 'К регулярным расходам';
        if (title === 'Деньги' || title === 'Счета')
            return 'К деньгам';
        return `Назад: ${title}`;
    }
    if (title === 'To pay')
        return 'Back to payable';
    if (title === labels.en.rules)
        return 'Back to recurring expenses';
    if (title === 'Money' || title === 'Accounts')
        return 'Back to money';
    return `Back to ${title}`;
}
